<template>
<div>
    <!-- BootstrapVue Done -->
    <base-header class="pb-6 pb-8 pt-5 pt-md-8 bg-gradient-dark">
    </base-header>
    <b-card>
        <b-container fluid class="mt--6">
            <b-row>
                <b-col>
                    <div class="card-wrapper">
                        <card>
                            <h2 class="mb-0">STATUS TIADA PERGERAKAN GAJI TAHUNAN</h2>
                            <b-row class="my-1">
                                <b-col sm="3">
                                    <label>NAMA</label>
                                </b-col>
                                <b-col sm="1">:</b-col>
                                <b-col sm="5">{{NamaPeribadi}}</b-col>
                            </b-row>
                            <b-row class="my-1">
                                <b-col sm="3">
                                    <label>NO KAD PENGENALAN</label>
                                </b-col>
                                <b-col sm="1">:</b-col>
                                <b-col sm="5" class="col text-left">{{NoKP}}</b-col>
                                <!-- <b-button variant="default">Carian Pengguna</b-button> -->
                            </b-row>
                            <!-- <b-row>
                                <b-col sm="7">
                                    <b-form-group label="STATUS TIADA PERGERAKAN GAJI TAHUNAN" v-slot="{ ariaDescribedby }">
                                        <b-form-radio-group id="btn-radios-1" v-model="selectedStatusTiadaPGT" :options="options" :aria-describedby="ariaDescribedby" name="radios-stacked" stacked></b-form-radio-group>
                                    </b-form-group>
                                </b-col>
                            </b-row> -->
                        </card>
                    </div>
                </b-col>
            </b-row>
            <br />
            <div >
                <b-card no-body>
                    <b-card-header class="border-0">
                        <h3 class="mb-0">TAHUN TIDAK MENERIMA PGT</h3>
                    </b-card-header>
                    <el-table class="table-responsive table" header-row-class-name="thead-light" :header-cell-style="{background:'#f6f9fc',color:'#8898aa'}" :data="objthnTdkPGT" style="width: 100%">
                        <el-table-column align="center" type="index" width="100px">
                        </el-table-column>

                        <el-table-column label="TAHUN" prop="YearID" min-width="200px" align="center">
                        </el-table-column>

                        <el-table-column label="Tindakan" min-width="150px" align="center">
                            <template slot="header">
                                <div style="width:100%;text-align:center">
                                    <base-button v-if="true" size="sm" icon type="success" class="mb-2" style="font-size: 0.8125rem" @click="addRow()">
                                        <span class="btn-inner--icon"><i class="ni ni-fat-add"></i></span>
                                        <span class="btn-inner--text">Tambah</span>
                                    </base-button>
                                </div>
                            </template>
                            <template slot-scope="scope">
                                <base-button v-if="true" size="sm" icon type="primary" class="mb-2" style="font-size: 0.8125rem" @click="delVal(scope)">
                                    <span class="btn-inner--icon"><i class="ni ni-paper-diploma"></i></span>
                                    <span class="btn-inner--text">delete</span>
                                </base-button>
                            </template>
                        </el-table-column>
                    </el-table>
                    <b-col>
                        <b-form-group>
                            <div>
                                <b-col>&nbsp;</b-col>
                                <b-col align="center">
                                    <b-button variant="success" type="submit" @click="simpan()" v-show="simpa2">SIMPAN</b-button>
                                    <b-button size="md" variant="primary" v-show="active" @click="next()">KEMBALI</b-button>
                                    <b-button size="md" variant="primary" v-show="active" @click="next()">SETERUSNYA</b-button>

                                </b-col>
                            </div>
                        </b-form-group>
                    </b-col>
                </b-card>
            </div>
            <!-- <div v-if="selectedStatusTiadaPGT == 0">
                <card header-classes="bg-transparent">
                    <b-button size="md" variant="danger" @click="nextNonData()">SETERUSNYA</b-button>
                    <br />
                </card>
            </div> -->
        </b-container>
    </b-card>

    <!--Form modal-->
    <modal :show.sync="modals.addYear" body-classes="p-0" >
        <template slot="header">
            <h3 class="mb-0">TAMBAH TAHUN</h3>
        </template>
        <template>
            <card>
                <validation-observer v-slot="{ invalid }">
                    <div class="pl-lg-4">
                        <validation-provider name="JENIS ADUAN" :rules="{ required: true }" v-slot="validationContext">
                            <b-row class="my-1">
                                <b-col sm="5">
                                    <label>Tahun Tidak Menerima PGT</label>
                                </b-col>
                                <b-col sm="5">
                                    <b-form-input id="YearID" v-model="obj.YearID"></b-form-input>
                                </b-col>
                                <!-- <b-col sm="5">
                        <b-button variant="default" @click="tambah">TAMBAH</b-button>
                    </b-col> -->
                            </b-row>
                        </validation-provider>
                        <b-row>
                            <b-col sm="12">
                                <b-button variant="success" type="submit" @click="tambah()" :disabled="invalid">SIMPAN</b-button>
                                <!-- <b-button size="md" variant="danger" @click="batal()">BATAL</b-button> -->
                            </b-col>
                        </b-row>

                    </div>
                </validation-observer>
            </card>
        </template>
        <template slot="footer"> &nbsp; </template>
    </modal>
</div>
</template>

<script>
import Store from "@/store";
import {
    Table,
    TableColumn,
    Pagination
} from "element-ui";
export default {
    name: "light-table",
    components: {
        [Table.name]: Table,
        [TableColumn.name]: TableColumn,

    },
    data() {
        return {
            modals: {
                addYear: false,
            },
            options: [{
                    text: 'YA',
                    value: '1'
                },
                {
                    text: 'TIDAK',
                    value: '0'
                }
            ],
            selectedStatusTiadaPGT: null,
            ObjLantikanSblm2003: {},
            active: false,
            simpa2: true,
            objthnTdkPGT: [],
            obj: [{

            }],

        }
    },
    methods: {
        showVal(row) {
            this.$emit("showModal", row);
            console.info("showVal", row);
        },
        indexMethod(index) {
            return (
                index + 1 + (this.currentPage - 1) * this.ClientPaging.totalRowPerPaging
            );
        },
        addRow() {
            this.modals.addYear = true;
        },
        delVal(scope) {
            //alert(scope.$index);

            this.objthnTdkPGT.splice(scope.$index, 1);
            this.simpa2 = true;
            this.active = false;
        },
        tambah() {
            //this.$emit("addItem", this.form);
            console.info("year id", this.obj)
            //this.objthnTdkPGT['YearID'] =this.YearID
            //this.obj.StatusTiadaPGT=this.selectedStatusTiadaPGT;
            this.objthnTdkPGT.push(this.obj);
            console.info("objthnTdkPGT id", this.objthnTdkPGT)
            this.modals.addYear = false;
            this.obj = [];
            this.simpa2 = true;
            this.active = false;
        },
        simpan() {

            this.objthnTdkPGT.StatusTiadaPGT=1;
            console.log("array", this.objthnTdkPGT)
            this.$store.commit("addMaklPegGaji", this.objthnTdkPGT);
            this.simpa2 = false;
            this.active = true;
            console.log(this.objthnTdkPGT);

            this.$router.push({
                name: 'MAKLUMAT KIRA GAJI',
            })

        },
        next() {
            console.log(this.NoKP)
            this.$router.push({
                name: 'STATUS ANJAKAN GAJI',
            })
        },

        nextNonData() {
            console.log("selectedStatusTiadaPGT", this.selectedStatusTiadaPGT)
            this.objthnTdkPGT.push(this.obj);
            this.objthnTdkPGT.StatusTiadaPGT=0;
            this.$store.commit("addMaklPegGaji", this.objthnTdkPGT);
            console.log(this.NoKP)
            this.$router.push({
                name: 'STATUS ANJAKAN GAJI',
            })
        }

    },
    computed: {
        MaklumatPeribadiInStore() {
            return Store.state.MaklumatPeribadi;

       // console.log("ini store",Store.state.MaklumatPeribadi);
            
        },

        IndpaparMaklPegGajiInStore(){
            return Store.state.paparMaklPegGaji
            //console.log("ini paparMaklPegGaji",Store.state.paparMaklPegGaji);
        }
        
    },
    created() {

        console.log("state",this.$store.state)    

        this.NamaPeribadi = this.$store.state.MaklumatPeribadi.Nama;
        this.NoKP = this.$store.state.MaklumatPeribadi.NoKP;

       //this.objthnTdkPGT= this.$store.state.MaklPegGaji[0];

    }
}
</script>

<style>
h2 {
    text-decoration: underline;
}

.numbers {
    text-decoration: underline;
    text-decoration-color: white;
}
</style>
